var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.object),function(value,key){return _c('li',{key:key},[(value.questionValue)?_c('strong',[_vm._v(_vm._s(value.questionValue)+":")]):_vm._e(),(_vm.isObject(value))?[_c('nested-answer-display',{attrs:{"object":value}})]:[_vm._v("\n      "+_vm._s(value.answerValue)+"\n    ")]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }